import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import './lib/i18n'
import App from './App.tsx'

// Always install the root-portal mock adapter in DEV (powers /root/* routes).
// Always install the demo-mode interceptor so toggling at runtime works without
// a page reload — it is a no-op when demo mode is off.
const { installAllMocks } = await import('@/lib/mock-adapter-registry')
await installAllMocks()

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
